import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {useState, useCallback} from 'react';
import ReactModal from 'react-modal';
import {FormattedMessage} from 'react-intl';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import CloseButton from '../close-button/close-button.jsx';

import helpIcon from '../../lib/assets/icon--help.svg';

import styles from './modal.css';

const CLOSE_DURATION = 150;

const ModalComponent = props => {
    const [closing, setClosing] = useState(false);

    const handleRequestClose = useCallback(() => {
        if (closing) return;
        setClosing(true);
        setTimeout(() => {
            setClosing(false);
            if (props.onRequestClose) props.onRequestClose();
        }, CLOSE_DURATION);
    }, [closing, props.onRequestClose]);

    return (
    <ReactModal
        isOpen
        className={classNames(styles.modalContent, props.className, {
            [styles.fullScreen]: props.fullScreen,
            [styles.closing]: closing
        })}
        contentLabel={props.contentLabel}
        overlayClassName={classNames(styles.modalOverlay, {
            [styles.overlayClosing]: closing
        })}
        onRequestClose={handleRequestClose}
    >
        <Box
            dir={props.isRtl ? 'rtl' : 'ltr'}
            direction="column"
            grow={1}
        >
            <div className={classNames(styles.header, props.headerClassName)}>
                {props.onHelp ? (
                    <div
                        className={classNames(
                            styles.headerItem,
                            styles.headerItemHelp
                        )}
                    >
                        <Button
                            className={styles.helpButton}
                            iconSrc={helpIcon}
                            onClick={props.onHelp}
                        >
                            <FormattedMessage
                                defaultMessage="Help"
                                description="Help button in modal"
                                id="gui.modal.help"
                            />
                        </Button>
                    </div>
                ) : null}
                <div
                    className={classNames(
                        styles.headerItem,
                        styles.headerItemTitle
                    )}
                >
                    {props.headerImage ? (
                        <img
                            className={styles.headerImage}
                            src={props.headerImage}
                            draggable={false}
                        />
                    ) : null}
                    {props.contentLabel}
                </div>
                <div
                    className={classNames(
                        styles.headerItem,
                        styles.headerItemClose
                    )}
                >
                    <CloseButton
                        size={CloseButton.SIZE_LARGE}
                        onClick={handleRequestClose}
                    />
                </div>
            </div>
            {props.children}
        </Box>
    </ReactModal>
    );
};

ModalComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    contentLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    fullScreen: PropTypes.bool,
    headerClassName: PropTypes.string,
    headerImage: PropTypes.string,
    isRtl: PropTypes.bool,
    onHelp: PropTypes.func,
    onRequestClose: PropTypes.func
};

export default ModalComponent;
